import { useEffect } from 'react';

export const useModalCloser = (id, showModal, handleClose) => {
  useEffect(() => {
    const listener = async (event) => {
      if (event.offsetX > event.target.clientWidth || event.offsetY > event.target.clientHeight) {
        return;
      }
      if (event.target.id) {
        if (event.target.id === `modal-${id}` && showModal) {
          handleClose(event);
        }
      }
    };
    document.addEventListener('mousedown', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [id, showModal, handleClose]);
};
